<template lang="pug" src="./divider-text.pug"></template>

<script>
import Parallax from 'vue-parallaxy'
export default {
  props: ['props', 'location'],
  components: {
    Parallax
  }
}
</script>



// WEBPACK FOOTER //
// divider-text.vue?54f584f6